// v2.55 - SSO Callback page for OAuth redirects (Google/Microsoft) - 2026-02-04
import React from 'react';
import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { colors } from '../theme/colors';

/**
 * SSOCallback handles the OAuth redirect from Google/Microsoft.
 * Clerk's AuthenticateWithRedirectCallback component processes the OAuth response
 * and completes the sign-in/sign-up flow.
 */
const SSOCallback: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: colors.background.default,
        gap: 2,
      }}
    >
      <CircularProgress sx={{ color: colors.primary.main }} size={48} />
      <Typography variant="body1" sx={{ color: colors.text.secondary }}>
        Completing sign-in...
      </Typography>
      {/* Clerk's callback handler - processes OAuth response and redirects */}
      <AuthenticateWithRedirectCallback />
    </Box>
  );
};

export default SSOCallback;
